export class ChildUserPermissions {
  resumen: boolean;
  ingresosPresupuestos: boolean;
  ingresosAlbaranes: boolean;
  ingresosCertificates: boolean;
  ingresosFacturas: boolean;
  ingresosRecurrentes: boolean;
  ingresosSubvenciones: boolean;
  ingresosTickets: boolean;
  ingresosAnticipos: boolean;
  ingresosFinancieros: boolean;
  ingresosIrpfCuenta: boolean;
  ingresosEstadisticas: boolean;
  ingresosOrdenesTrabajo: boolean;
  gastos: boolean;
  contactos: boolean;
  finanzas: boolean;
  inversion: boolean;
  productos: boolean;
  socios: boolean;
  personal: boolean;
  contabilidad: boolean;
  fiscalidad: boolean;
  ficheros: boolean;
  configuracion: boolean;
  tpv: boolean;
}